var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoUrl)?_c('div',{ref:"container",class:_vm.classNames},[(_vm.resized)?_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","allowfullscreen":"","src":_vm.videoUrl}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }